export default [
  {
    component: () => import('@/modules/frontendhome/views/Home.vue'),
    name: 'frontend-home',
    path: '/home',
  },
]
